import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <small className="footer__text">
        © {new Date().getFullYear()} Notflix — Tutti i diritti riservati.
      </small>
    </footer>
  )
}
